import { api } from "../api";
import { StatisticsPeriod } from "../../model/enum/StatisticsPeriod";
import { BarChartData } from "../../model/statistics/BarChart";
import { fromPeriodToSinceUntil } from "../../helpers/fromPeriodToSinceUntil";
import { parseStatisticsForBarChart } from "../../parsers/statistics/parseStatisticsForBarChart";

export const getWaterStatistics = async (patientId: string, period: StatisticsPeriod): Promise<BarChartData[]> => {
  const { since, until } = fromPeriodToSinceUntil(period);
  const response = await api.services.patientChallenge.getPatientChallengesProgress(patientId, since, until);
  return parseStatisticsForBarChart(response.data.water, since, until);
};
